module.exports = __webpack_public_path__ + "media/components/weather-icon/static/nightcloud-e62105ab8f418dcb3501ce6622a9740c.png";